import './chatWithSummaryNew.css';
import { Copy } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { Popover } from '@cloudscape-design/components'; // or use your tooltip lib
import { marked } from 'marked';
import { useLocation } from 'react-router-dom';
import { createLogger } from '../../../helpers/Logger';
import DOMPurify from 'dompurify';

const logger = createLogger({ prefix: '[Chat Answer]' });

const citeRegex = /<<cid:([A-Fa-f0-9]{24})>>/g;
interface CitationTextProps {
  /** The raw text containing citations in the form ‹citationId› */
  text: string;
  /** Called when a citation is clicked; receives the citation ID string */
  onCiteClick: (id: string, label?: string) => void;
  prevAnswer: boolean;
  citationObject?: { [key: string]: number };
  type?: string;
  contextArray?: any[];
  any?: any;
  setCitationIndexes?: (arg: { [key: string]: number }) => void;
}

export const getIdsFromText = (text: string): string[] => {
  // const regex = /‹(.*?)›/g;
  // const regex = /‹([a-f0-9]{24})›/g;
  const matches: string[] = [];
  let match;
  console.log('========string=======', text);
  while ((match = citeRegex.exec(text)) !== null) {
    matches.push(match[1]);
  }
  logger.info('matches', matches);
  return matches;
};

export const CitationText: React.FC<CitationTextProps> = ({
  text,
  onCiteClick,
  prevAnswer,
  citationObject,
  type,
  contextArray,
  any,
  setCitationIndexes
}) => {
  // console.log('raw test in answer block:: ', text);
  const [html, setHtml] = useState('');
  const [tooltipText, setTooltipText] = useState('Click to copy');

  const location = useLocation();
  const path = location.pathname.split('/');

  const convertMarkdown = async () => {
    getIdsFromText(text);
    logger.info('Convert Markdown Running');
    let localCite: { [key: string]: number };

    // if (citationObject) {
    //   localCite = citationObject;
    // } else {
    // console.log('creating local cite object');
    const idsWithIndex = getIdsFromText(text);
    localCite = {} as { [key: string]: number };
    let count = 1;
    idsWithIndex.forEach((ele, index) => {
      if (localCite) {
        if (!localCite[ele]) {
          localCite[ele] = count;
          count++;
        }
      }
    });
    if (setCitationIndexes) {
      setCitationIndexes(localCite);
    }
    // }
    // const htmlWithCitations = await marked.parse(text);
    if (any?.ExternalAnswer) {
      console.log('localCite Object', localCite);
      console.log('citation Object', citationObject);
      console.log('context array', contextArray);
    }
    const htmlWithCitations = text;
    logger.info('html with citations', htmlWithCitations);
    const citationArray: string[] = [];
    const seenCitationSet: Set<string> = new Set();

    const replacedHtml = htmlWithCitations.replace(
      // /‹([^›]*)›/g,
      // /‹([a-f0-9]{24})›/g,
      citeRegex,
      // citeRegex,
      (_, citationId) => {
        // console.log('citation id in replace', citationId);
        const citationLabel = localCite![`${citationId}`];

        if (type === 'rfp') {
          const citeInfo = contextArray?.filter(
            (ele) => ele._id === citationId
          )[0];
          if (!seenCitationSet.has(citeInfo?._id)) {
            citationArray.push(
              `<p><span class="text-blue-600 underline cursor-pointer" data-citation-id="${citationId}" data-citation-label="${citationLabel}">&lt;${citationLabel}&gt;</span>&nbsp;${citeInfo?.Document?.documentFileName}&nbsp;(Pg:&nbsp;${citeInfo?.PageNumber ?? citeInfo?.pageNumber})</p>`
            );
            seenCitationSet.add(citeInfo?._id);
          }
          return `<span class="text-blue-600 underline cursor-pointer" data-citation-id="${citationId}" data-citation-label="${citationLabel}">&lt;${citationLabel}&gt;</span>`;
        } else {
          return `<span class="text-blue-600 underline cursor-pointer" data-citation-id="${citationId}" data-citation-label="${citationLabel}">&lt;${citationLabel}&gt;</span>`;
        }
      }
    );
    if (any?.prevExternalAnswer) {
      citationArray.push(...any?.originalHardCitations);
    }
    if (type === 'rfp') {
      console.log('citation array', citationArray);
      const parsedMarkdown = await marked.parse(replacedHtml);
      const clean = DOMPurify.sanitize(replacedHtml);
      const newLayout = `
      ${clean}
      <div>
        ${citationArray.join('')}
      </div>`;

      setHtml(newLayout);
    } else {
      console.log('normal answer replaced text', replacedHtml);
      // const parsedMarkdown = await marked.parse(replacedHtml);
      // console.log('parsed Markdown', parsedMarkdown);
      const clean = DOMPurify.sanitize(replacedHtml);
      setHtml(clean);
    }
  };
  useEffect(() => {
    console.log('going to run convertMarkdown');
    convertMarkdown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, citationObject]);
  useEffect(() => {
    if (!text) return;
    console.log('going to run convertMarkdown on mount');
    convertMarkdown();
  }, []);

  function htmlToPlainText(htmlString: string) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    return tempDiv.textContent || tempDiv.innerText || '';
  }

  const copyToClipboard = async () => {
    // const regex = /<\d+>/g;
    const plainText = htmlToPlainText(html);
    // const result = plainText.replace(regex, '');
    await navigator.clipboard.writeText(plainText);

    setTooltipText('Copied!');
    setTimeout(() => setTooltipText('Click to copy'), 2000);
  };
  const regexNoContext =
    /no sufficient context provided to answer the question/i;

  return (
    <div className="prose prose-sm text-gray-800 relative">
      {/* {!prevAnswer && currentLocation.includes('search') && ( */}

      <div className="absolute top-[-2vh] right-[0%]">
        <Popover
          dismissButton={false}
          position="top"
          size="small"
          triggerType="custom"
          content={tooltipText}
        >
          <Copy
            size={16}
            onClick={() => copyToClipboard()}
            className="cursor-pointer p-0"
          />
        </Popover>
      </div>

      {regexNoContext.test(html) ? (
        <div className="max-w-xl mx-auto mt-6 p-5 rounded-lg bg-gray-50 border border-gray-200 text-gray-800 shadow">
          <div className="flex items-start gap-3">
            <svg
              className="w-6 h-6 text-gray-500 mt-1"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 8v4m0 4h.01M21 12A9 9 0 113 12a9 9 0 0118 0z"
              />
            </svg>

            <div>
              <p className="text-sm leading-relaxed">
                It looks like the available material doesn’t include enough
                relevant information to generate a confident answer. Consider{' '}
                <strong>expanding your question</strong> or{' '}
                <strong>providing additional context or documents</strong> for
                best results.
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="llm-response"
          dangerouslySetInnerHTML={{ __html: html }}
          onClick={(e) => {
            const target = e.target as HTMLElement;
            if (target?.dataset?.citationId) {
              onCiteClick(
                target?.dataset?.citationId,
                target?.dataset.citationLabel
              );
            }
          }}
        />
      )}
    </div>
  );
};
